
import React, { useState, useEffect, useRef } from "react";
import Navbar from "../NavBar/Navbar";
import "./SettingEntityInfo.css";
import SignUP from "../login/signUP";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Typography from "@mui/material/Typography";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PhoneInput from 'react-phone-number-input';
import './SettingEntityInfo.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ValidationMessages from "../utils/validationMessages";
import { GetUserDetailsFromToken } from '../../Services/employeeService.jsx';
import { useUser } from "../utils/UserContext.jsx";
import Holidays from "./Holidays";
import Pricing from "./Pricing.jsx";
import { useMsalInstances } from "../utils/MsalInstancesContext";
import { ChangePasswordRequest } from "../utils/msalConfigB2C";
import { BrowserAuthError } from "@azure/msal-browser";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/default-layout';
import FadeLoader from "react-spinners/FadeLoader";


const SettingEntityInfo = () => {
  const [, setPasswordRequirements] = useState({
    minLength: false,
    uppercase: false,
    lowercase: false,
    digit: false,
    specialChar: false,
    notGuessable: false,
    noSpaces: false,
  });
  const navigate = useNavigate();

  const [mapvisible] = useState(false);
  const { section } = useParams();
  const [activeSection, setActiveSection] = useState(section || "entity");
  const [, setLoading] = useState(false);
  const [userInfo, setUserDetails] = useState(null);
  const [empInfo, setEmpDetails] = useState(null);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [profileChange, setProfilechange] = useState(false);
  const [verificationRequired, setVerificationrequired] = useState("");
  const [personalData, setPersonalData] = useState({});
  const [showdialogue, setShowdialogue] = useState(false);
  const [verificationenabled, setVerificationenabled] = useState(false);
  const [radiobuttonval, setRadiobuttonval] = useState("");
  const [oldMobilenum, setOldMobilenum] = useState();
  const [errors, setErrors] = useState({});
  const [, setEmaiErr] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [, setMailingAddressZipCode] = useState("");
  const [, setZipcodeWarning] = useState("");
  const [, setMailingAddressCity] = useState("");
  const [, setCities] = useState([]);
  const [stateLogedInUser, setStateLogedInUser] = useState();
  const [stateLogedInEmployee, setStateLogedInEmployee] = useState();
  const [isEmployee, setIsEmployee] = useState(false);

  const radiobuttonoption = useRef();
  const [states, setStates] = useState([]);
  const [internalEmployeeEmail, setInternalEmployeeEmail] = useState("");
  const { userDetails, employeeData } = useUser();
  const { b2cInstance } = useMsalInstances();
  const [showSuccessDialog, setShowSuccessDialog] = useState(false);
  const [isAuthInProgress, setIsAuthInProgress] = useState(false);
  const [isReitOwner, setIsReitOwner] = useState(false);

  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const pdfUrl = `${userInfo?.agreementFileURL || empInfo?.agreementFileURL}`;

  const hostPath = process.env.REACT_APP_API_BASE_URL;
  const hostHeader = process.env.REACT_APP_CUSTOM_HEADER;

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  var personaldata = {};
  const [formData, setFormData] = useState({
    EntityName: "",
    EnityMailingAdderess: "",
    EnityMailingAdderess2: "",
    Country: "United States",
    CityId: "",
    Zipcode: "",
    StateId: "",
    EmailId: "",
  });

  const [profileData, setProfileData] = useState({
    FirstName: "",
    LastName: "",
    EmailId: "",
    MobileNumber: "",
    OfficeNumber: "",
    NewEmailId: "",
  });

  const handleResetPassword = async () => {
    try {
      if (isAuthInProgress) {
        console.warn("Popup already triggered. Please wait.");
        return;
      }

      setIsAuthInProgress(true);

      const response = await b2cInstance.loginPopup(ChangePasswordRequest);
      console.log("Password Updated Successfully:", response);
      setShowSuccessDialog(true);
    } catch (error) {
      if (error instanceof BrowserAuthError && error.errorCode === "interaction_in_progress") {
        console.warn("Another authentication popup is already open.");
      } else {
        console.error("Failed to Update Password:", error);
      }
    } finally {
      setIsAuthInProgress(false);
    }
  };

  // Determine if user is employee or entity owner
  useEffect(() => {
    if (employeeData) {
      setStateLogedInEmployee(employeeData?.emailId);
      setIsEmployee(true);
    } else if (userDetails) {
      setStateLogedInUser(userDetails?.emailId);
      setIsEmployee(false);
    }
  }, [userDetails, employeeData]);

  // Sub Owners (employees) may view Entity Information but cannot edit it
  const canEditEntityInfo = !isEmployee && !empInfo;

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userData = await GetUserDetailsFromToken();
        setInternalEmployeeEmail(userData?.companyEmail);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchUserData();
  }, []);

  const fetchUserDetails = async () => {
    try {
      const response = await fetch(`${hostPath}/api/GetUserDetails`, {
        method: "POST",
        headers: { "x-functions-key": `${hostHeader}` },
        body: JSON.stringify({ EmailId: stateLogedInUser }),
      });

      if (!response.ok) {
        toast.error("Failed to fetch user details");
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setUserDetails(data[0]);
      setIsReitOwner(data[0]?.isReitOwner);

      setFormData({
        EntityName: data[0]?.entityName || "",
        EnityMailingAdderess: data[0]?.enityMailingAdderess || "",
        EnityMailingAdderess2: data[0]?.enityMailingAdderess2 || "",
        Country: data[0]?.country || "United States",
        CityId: data[0]?.cityId || "",
        Zipcode: data[0]?.zipcode || "",
        StateId: data[0]?.stateId || "",
        EmailId: data[0]?.emailId,
      });

      setProfileData({
        FirstName: data[0]?.firstName || "",
        LastName: data[0]?.lastName || "",
        EmailId: data[0]?.emailId || "",
        MobileNumber: data[0]?.mobileNumber || "",
        OfficeNumber: data[0]?.officeNumber || "",
        NewEmailId: "",
      });

      setOldMobilenum(data[0]?.mobileNumber);
    } catch (error) {
      console.error("Failed to fetch user details:", error);
    }
  };

  // Fetch full employee details by email
  const fetchEmpDetailsByEmail = async () => {
    try {
      const response = await fetch(`${hostPath}/api/GetEmpDetails`, {
        method: "POST",
        headers: { "x-functions-key": `${hostHeader}` },
        body: JSON.stringify({ EmailId: stateLogedInEmployee }),
      });

      if (!response.ok) {
        toast.error("Failed to fetch employee details");
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      setEmpDetails(data[0]);
      setIsReitOwner(data[0]?.isReitOwner);

      setFormData({
        EntityName: data[0]?.entityName || "",
        EnityMailingAdderess: data[0]?.enityMailingAdderess || "",
        EnityMailingAdderess2: data[0]?.enityMailingAdderess2 || "",
        Country: data[0]?.country || "United States",
        CityId: data[0]?.cityId || "",
        Zipcode: data[0]?.zipcode || "",
        StateId: data[0]?.stateId || "",
        EmailId: data[0]?.emailId,
      });

      setProfileData({
        FirstName: data[0]?.firstName || "",
        LastName: data[0]?.lastName || "",
        EmailId: data[0]?.emailId || "",
        MobileNumber: data[0]?.mobileNumber || "",
        OfficeNumber: data[0]?.officeNumber || "",
        NewEmailId: "",
      });

      setOldMobilenum(data[0]?.mobileNumber);

      // If employee entity info is empty, fetch from owner using entityRegistrationID
      if (!data[0]?.entityName && data[0]?.entityRegistrationID) {
        try {
          const ownerRes = await fetch(`${hostPath}/api/GetUserDetailsbyid`, {
            method: "POST",
            headers: { "x-functions-key": `${hostHeader}` },
            body: JSON.stringify({ EntityRegistrationID: data[0].entityRegistrationID }),
          });
          if (ownerRes.ok) {
            const ownerData = await ownerRes.json();
            const owner = ownerData[0];
            if (owner?.entityName) {
              setFormData(prev => ({
                ...prev,
                EntityName: owner.entityName || prev.EntityName,
                EnityMailingAdderess: owner.enityMailingAdderess || prev.EnityMailingAdderess,
                EnityMailingAdderess2: owner.enityMailingAdderess2 || prev.EnityMailingAdderess2,
                Country: owner.country || prev.Country,
                CityId: owner.cityId || prev.CityId,
                Zipcode: owner.zipcode || prev.Zipcode,
                StateId: owner.stateId || prev.StateId,
              }));
            }
          }
        } catch (ownerErr) {
          console.warn("Could not fetch owner entity details:", ownerErr);
        }
      }
    } catch (error) {
      console.error("Failed to fetch employee details:", error);
    }
  };

  useEffect(() => {
    if (stateLogedInUser) {
      fetchUserDetails();
    }
    if (stateLogedInEmployee) {

      fetchEmpDetailsByEmail();
    }
  }, [stateLogedInUser, stateLogedInEmployee, hostHeader]);

  const handleSectionChange = (newSection) => {
    if (newSection === activeSection) return;
    setActiveSection(newSection);
    navigate(`/settings/${newSection}`);
  };

  useEffect(() => {
    setActiveSection(section || "entity");
  }, [section]);

  const handleInputChange = (e) => {
    if (!canEditEntityInfo) return;
    const { name, value } = e.target;
    setErrors(prevErrors => ({
      ...prevErrors,
      [name]: ''
    }));
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const response = await axios.get(`${hostPath}/api/GetUSStates`, {
        }
        );
        var data = response.data.filter((country) =>
          /^[a-zA-Z0-9]+$/.test(country.iso2)
        );
        data.sort((a, b) => a.name.localeCompare(b.name));
        setStates(data);
      } catch (error) {
        console.error("Error fetching states:", error);
      }
    };

    fetchStates();
  }, []);

  useEffect(() => {
    if (searchValue?.trim() !== "") {
      axios
        .get(
          `https://atlas.microsoft.com/search/address/json?&subscription-key=iKSTDEFy2eA9QfhSETwDwwnQoR_36iCV5wv18ubSOBw&api-version=1.0&language=en-US&query=${searchValue}&filter=countryCode=US`
        )
        .then((response) => {
          const results = response.data.results;
          if (results && results.length > 0) {
            const suggestedLocations = results
              .filter((result) => result.address.countryCode === "US")
              .map((result) => result.address);
            setSuggestions(suggestedLocations);
          }
        })
        .catch((error) => {
          console.error("Error fetching location suggestions:", error);
        });
    } else {
      setSuggestions([]);
    }
  }, [searchValue]);

  const fetchCities = async (data) => {
    try {
      const response = await axios.post(
        `${hostPath}/api/GetCitiesByState`, { stateId: data });
      setCities(response.data);
      return response.data;
    } catch (error) {
      return [];
    }
  };

  const handleProfileChange = (e) => {
    const { name, value } = e.target;

    if (name === 'MobileNumber' || name === "OfficeNumber") {
      let formattedValue = value?.startsWith('+1') ? value : `+1${value}`;
      let digits = formattedValue.replace(/\D/g, '');
      if (digits.length > 11) {
        digits = digits.substring(0, 11);
      }
      formattedValue = `+1${digits.substring(1)}`;
      setProfileData({
        ...profileData,
        [name]: formattedValue,
      });
    } else {
      setProfileData({
        ...profileData,
        [name]: value,
      });
    }
  };

  const validateFields = async (fields) => {
    const errors = {};
    const alphabetRegex = /^[A-Za-zÀ-ÿ\s'\-]*$/;
    const alphaNumericRegex = /^[a-zA-Z0-9À-ÿ\s,'\-\.#\/&]*$/;
    const digitRegex = /^\d*$/;
    let emailexists = false;

    const currentInfo = isEmployee ? empInfo : userInfo;
    const currentEmail = isEmployee ? stateLogedInEmployee : stateLogedInUser;

    if (profileData?.EmailId && profileData?.EmailId !== currentInfo?.emailId) {
      emailexists = await checkEmailExistence(profileData.EmailId);
    }

    if (!formData?.EntityName?.trim()) {
      errors.EntityName = ValidationMessages.entityName;
    } else if (!alphaNumericRegex.test(formData.EntityName.trim())) {
      errors.EntityName = ValidationMessages.entityNameConstraints;
    }

    if (!formData?.EnityMailingAdderess?.trim()) {
      errors.EnityMailingAdderess = ValidationMessages.mailingaddressrequired;
    } else if (!/^[a-zA-Z0-9À-ÿ\s,'\-\.#\/&]*$/.test(formData.EnityMailingAdderess.trim())) {
      errors.EnityMailingAdderess = ValidationMessages.mailingConstraints;
    }

    if (!formData?.StateId?.trim()) {
      errors.StateId = ValidationMessages.statereq;
    } else if (!/^[A-Za-z\s]+$/.test(formData.StateId.trim())) {
      errors.StateId = ValidationMessages.stateConstraints;
    }

    if (!formData?.CityId?.trim()) {
      errors.CityId = ValidationMessages.cityReq;
    } else if (!/^[a-zA-Z0-9À-ÿ\s,'\-\.#\/&]*$/.test(formData.CityId.trim())) {
      errors.CityId = ValidationMessages.cityConstraints;
    }

    if (!formData?.Zipcode?.trim()) {
      errors.Zipcode = ValidationMessages.zipReq;
    } else if (!digitRegex.test(formData.Zipcode)) {
      errors.Zipcode = ValidationMessages.zipconst1;
    } else if (formData.Zipcode.length !== 5) {
      errors.Zipcode = ValidationMessages.zipconst2;
    }

    if (!profileData?.FirstName?.trim()) {
      errors.FirstName = ValidationMessages.firstNameRequired;
    } else if (!alphabetRegex.test(profileData.FirstName)) {
      errors.FirstName = ValidationMessages.firstNameAlphabets;
    }

    if (!profileData?.LastName?.trim()) {
      errors.LastName = ValidationMessages.lastNameRequired;
    } else if (!alphabetRegex.test(profileData.LastName)) {
      errors.LastName = ValidationMessages.lastNameAlphabets;
    }

    if (!profileData?.EmailId?.trim()) {
      errors.EmailId = ValidationMessages.emailRequired;
    } else if (!/\S+@\S+\.\S+/.test(profileData.EmailId)) {
      errors.EmailId = ValidationMessages.emailInvalid;
    } else if (currentEmail !== profileData?.EmailId && emailexists) {
      errors.EmailId = ValidationMessages.emailAlredyExist;
    }

    if (!profileData?.MobileNumber) {
      errors.MobileNumber = ValidationMessages.phoneRequired;
    } else {
      const phoneNumber = profileData.MobileNumber.replace(/\D/g, "");
      if (phoneNumber.length !== 11 || !phoneNumber.startsWith("1")) {
        errors.MobileNumber = ValidationMessages.inValidPhone;
      }
    }

    if (profileData?.OfficeNumber && !/^\+1\d{10}$/.test(profileData.OfficeNumber)) {
      errors.OfficeNumber = ValidationMessages.OfficePhone;
    }

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  async function checkEmailExistence(email) {
    setLoading(true);
    const emailid = { EmailId: email };
    const requestOptions = {
      method: "POST",
      headers: {
        "x-functions-key": `${hostHeader}`,
      },
      body: JSON.stringify(emailid),
    };

    try {
      const response = await axios.post(
        `${hostPath}/api/CheckEmailIdExist`,
        requestOptions.body,
        { headers: requestOptions.headers }
      );
      if (response.data === true) {
        setEmaiErr(true);
        return true;
      } else {
        setEmaiErr(false);
        return false;
      }
    } catch (error) {
      console.error("Error:", error);
      return false;
    } finally {
      setLoading(false);
    }
  }

  const handleSaveChanges = async (val) => {
    if (val !== "profile" && !canEditEntityInfo) {
      toast.error("You do not have permission to update Entity Information.");
      return;
    }
    if (await validateFields(formData)) {
      setShowConfirmation(true);
      if (val === "profile") {
        setProfilechange(true);
      }
    }
  };

  const handleContinue = () => {
    setShowdialogue(false);
    setVerificationenabled(true);
    setRadiobuttonval(radiobuttonoption.current);
  };

  const handleBack = () => {
    setVerificationenabled(false);
    setShowdialogue(false);
    setProfilechange(false);
  };

  const handleProfileUpdateComplete = (message, errorMessage) => {
    setVerificationenabled(false);
    setShowdialogue(false);
    setProfilechange(false);

    if (errorMessage) {
      toast.error(errorMessage);
      return;
    }

    toast.success(message || "Profile updated successfully");

    if (isEmployee) {
      fetchEmpDetailsByEmail();
    } else {
      fetchUserDetails();
    }
  };

  const handleCancel = () => {
    setShowdialogue(false);
  };

  const handleradiobutton = (val) => {
    radiobuttonoption.current = val;
  };

  const confirmSaveChanges = async () => {
    if (profileChange) {
      confirmProfileChanges();
    } else {
      if (!canEditEntityInfo) {
        setShowConfirmation(false);
        toast.error("You do not have permission to update Entity Information.");
        return;
      }
      setShowConfirmation(false);
      const updatedFields = {};
      const currentInfo = isEmployee ? empInfo : userInfo;

      for (const key in formData) {
        if (formData[key] !== currentInfo[key]) {
          updatedFields[key] = formData[key];
        }
      }
      updatedFields["EmailId"] = formData["EmailId"];
      updatedFields["isReitOwner"] = currentInfo?.isReitOwner;

      try {
        const apiEndpoint = isEmployee
          ? `${hostPath}/api/UpdateEmpDetails`
          : `${hostPath}/api/updateuserdetails`;

        const response = await fetch(apiEndpoint, {
          method: "PUT",
          headers: {
            "x-functions-key": `${hostHeader}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedFields),
        });

        const data = await response.json();
        if (data.status === true) {
          toast.success(data.responseMessage);
        }
        if (!response.ok) {
          toast.error(data.responseMessage);
          throw new Error("Network response was not ok");
        }

        if (isEmployee) {
          fetchEmpDetailsByEmail();
        } else {
          fetchUserDetails();
        }
      } catch (error) {
        toast.error(error.message);
        console.error("Failed to update details:", error);
      }
    }
  };

  const confirmProfileChanges = async () => {
    setShowConfirmation(false);
    const currentInfo = isEmployee ? empInfo : userInfo;
    const currentEmail = isEmployee ? stateLogedInEmployee : stateLogedInUser;

    for (const key in profileData) {
      personaldata[key] = profileData[key];

      if (
        profileData["EmailId"] !== currentInfo["emailId"] &&
        profileData["MobileNumber"] !== currentInfo["mobileNumber"]
      ) {
        setVerificationrequired("emailmobile");
        setShowdialogue(true);
      } else if (profileData["MobileNumber"] !== currentInfo["mobileNumber"]) {
        setVerificationrequired("mobile");
        setShowdialogue(true);
      } else if (profileData["EmailId"] !== currentInfo["emailId"]) {
        setVerificationrequired("email");
        setShowdialogue(true);
      }

      if (profileData["EmailId"] !== currentEmail) {
        personaldata["NewEmailId"] = profileData["EmailId"];
        personaldata["EmailId"] = currentEmail;
      }

      if (
        profileData["EmailId"] === currentInfo["emailId"] &&
        profileData["MobileNumber"] === currentInfo["mobileNumber"] &&
        Object.keys(personaldata).length === 6
      ) {
        updateProfile(personaldata);
      }
      setPersonalData(personaldata);
    }
  };

  const updateProfile = async (updatedFields) => {
    try {
      const apiEndpoint = isEmployee
        ? `${hostPath}/api/UpdateEmpProfile`
        : `${hostPath}/api/UpdateProfile`;

      const response = await fetch(apiEndpoint, {
        method: "PUT",
        headers: {
          "x-functions-key": `${hostHeader}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(updatedFields),
      });

      const data = await response.json();
      if (data.status === true) {
        toast.success(data.responseMessage);
      }
      if (!response.ok) {
        toast.error(data.responseMessage);
        throw new Error("Network response was not ok");
      }

      return data;
    } catch (error) {
      console.error("Failed to update profile:", error);
      throw error;
    }
  };

  const cancelSaveChanges = () => {
    setShowConfirmation(false);
  };

  const currentInfo = isEmployee ? empInfo : userInfo;

  if (!currentInfo && !internalEmployeeEmail) {
    return (
      <div className="loader-overlay">
        <FadeLoader />
      </div>
    );
  }


  const validatePassword = (password) => {
    const requirements = {
      minLength: password.length >= 8,
      uppercase: /[A-Z]/.test(password),
      lowercase: /[a-z]/.test(password),
      digit: /\d/.test(password),
      specialChar: /[!@#$%^&*]/.test(password),
      noSpaces: !/\s/.test(password),
    };
    setPasswordRequirements(requirements);
    const allRequirementsMet = Object.values(requirements).every(
      (requirement) => requirement
    );
    return allRequirementsMet;
  };

  const handleSearchChange = (e) => {
    if (!canEditEntityInfo) return;
    const { name, value } = e.target;
    if (name === "EnityMailingAdderess") {
      if (name) {
        errors.EnityMailingAdderess = "";
        setFormData({ ...formData, [name]: value });
      } else {
        errors.EnityMailingAdderess = ValidationMessages.mailingaddressrequired;
      }
    }
    setSearchValue(e.target.value);
  };

  const handleAddressSelect = (address) => {
    if (!canEditEntityInfo) return;
    const selectedState = states.find(
      (state) =>
        state.name.toLowerCase() === address?.countrySubdivisionName?.toLowerCase()
    );
    setMailingAddressZipCode(address?.postalCode);
    setMailingAddressCity(address?.municipality);
    errors.CityId = "";
    errors.Zipcode = "";
    setZipcodeWarning("");
    const shortAddress = address?.freeformAddress || [
      address?.streetNameAndNumber || `${address?.streetNumber || ""} ${address?.streetName || ""}`.trim(),
      address?.municipality,
      `${address?.countrySubdivision || ""} ${address?.postalCode || ""}`.trim(),
    ].filter(Boolean).join(', ');

    if (selectedState) {
      fetchCities(selectedState.iso2).then((citylist) => {
        let selectedCity = citylist?.find(
          (city) =>
            city.name.toLowerCase().trim() === address?.municipality?.toLowerCase().trim()
        );

        if (!selectedCity) {
          selectedCity = citylist?.find((city) =>
            address?.municipality?.toLowerCase().includes(city.name.toLowerCase())
          );
        }

        const finalCityName = selectedCity ? selectedCity.name : address?.municipality || "";

        setFormData((prevState) => ({
          ...prevState,
          CityId: finalCityName,
        }));
      });
    } else {
      setFormData((prevState) => ({
        ...prevState,
        CityId: address?.municipality || "",
      }));
    }

    setFormData((prevState) => ({
      ...prevState,
      EnityMailingAdderess: shortAddress || "",
      Zipcode: address?.postalCode || "",
      StateId: selectedState ? selectedState.iso2 : "",
    }));

    setSearchValue("");
    setSuggestions([]);
  };

  return (
    <>
      <Navbar mapvisible={mapvisible} />
      {!verificationenabled ? (
        <div className="container">
          <ToastContainer />
          <>
            <h2 className="settingheader">Settings</h2>
            <div className="row">
              <div className="col-3">
                <div className="Entityinfo">
                  <h6 className="personinfoheader">PERSONAL INFORMATION</h6>
                  {currentInfo && (
                    <>
                      <span
                        className={`sideHeader ${activeSection === "entity" ? "active" : ""}`}
                        onClick={() => handleSectionChange("entity")}
                      >
                        Entity Information
                      </span>
                      <br />
                      <span
                        className={`sideHeader ${activeSection === "profile" ? "active" : ""}`}
                        onClick={() => handleSectionChange("profile")}
                      >
                        Profile Information
                      </span>
                      <br />
                      <span
                        className={`sideHeader ${activeSection === "password" ? "active" : ""}`}
                        onClick={() => handleSectionChange("password")}
                      >
                        Change Password
                      </span>
                      <br />

                      {isReitOwner && userInfo && (
                        <span
                          className={`sideHeader ${activeSection === "agreementSignature" ? "active" : ""}`}
                          onClick={() => handleSectionChange("agreementSignature")}
                        >
                          REITs Document
                        </span>
                      )}
                      <br />
                      <span
                        className={`sideHeader ${activeSection === "pricing" ? "active" : ""}`}
                        onClick={() => handleSectionChange("pricing")}
                      >
                        Pricing Page
                      </span>
                      <br />
                    </>
                  )}
                  {(internalEmployeeEmail) && (
                    <>
                      <span
                        className={`sideHeader ${activeSection === "pricing" ? "active" : ""}`}
                        onClick={() => handleSectionChange("pricing")}
                      >
                        Pricing Page
                      </span>
                      <br />
                      <span
                        className={`sideHeader ${activeSection === "holidays" ? "active" : ""}`}
                        onClick={() => handleSectionChange("holidays")}
                      >
                        Configure Holidays
                      </span></>

                  )}

                </div>
              </div>
              <div className="col-9">
                {activeSection === "entity" && (userInfo || empInfo) && (
                  <div className="entity-info-container">
                    <h2 style={{ textAlign: "left" }}>Entity Information</h2>
                    <hr />
                    <form className="entity-form">
                      <div className="form-entity">
                        <label>Entity Name*</label>
                        <input
                          type="text"
                          name="EntityName"
                          maxLength={50}
                          value={formData?.EntityName}
                          onChange={handleInputChange}
                          disabled={!canEditEntityInfo}
                          style={!canEditEntityInfo ? { cursor: "not-allowed" } : {}}
                        />
                        {errors.EntityName && (
                          <p style={{ textAlign: "left", color: "red" }}>
                            {" "}
                            {errors.EntityName}
                          </p>
                        )}
                      </div>
                      <div className="form-entity">
                        <label>Country*</label>
                        <input
                          type="text"
                          name="Country"
                          value={formData?.Country}
                          disabled={true}
                          onChange={handleInputChange}
                          style={{ cursor: "not-allowed" }}

                        />
                      </div>
                      <div className="form-entity">
                        <label>Entity Mailing Address*</label>
                        <input
                          type="text"
                          className={`form-control ${formData.EnityMailingAdderess ? "input-active" : ""
                            }`}
                          id="password"
                          maxLength={100}
                          placeholder="Enter address "
                          name="EnityMailingAdderess"
                          value={formData.EnityMailingAdderess}
                          disabled={!canEditEntityInfo}
                          style={!canEditEntityInfo ? { cursor: "not-allowed" } : {}}
                          onChange={(e) => {
                            handleSearchChange(e);
                          }}
                        />
                        {canEditEntityInfo && suggestions.length > 0 && (
                          <ul className="search-results Addrees-search-results">
                            {suggestions.map((result) => (
                              <li onClick={() => handleAddressSelect(result)}>
                                {result.freeformAddress}
                              </li>
                            ))}
                          </ul>
                        )}
                        {errors.EnityMailingAdderess && (
                          <div className="error-message mandatorymark">
                            {errors.EnityMailingAdderess}
                          </div>
                        )}
                      </div>

                      <div className='form-entity'>
                        <label>Entity Mailing Address 2</label>
                        <input
                          type="text"
                          name="EnityMailingAdderess2"
                          value={formData?.EnityMailingAdderess2}
                          onChange={handleInputChange}
                          disabled={!canEditEntityInfo}
                          style={!canEditEntityInfo ? { cursor: "not-allowed" } : {}}
                        />
                      </div>
                      <div className="form-entity">
                        <label>ZIP Code*</label>
                        <input
                          type="text"
                          name="Zipcode"
                          maxLength={5}
                          value={formData?.Zipcode}
                          onChange={handleInputChange}
                          disabled={!canEditEntityInfo || !!formData?.Zipcode}
                          style={!canEditEntityInfo || formData?.Zipcode ? { cursor: "not-allowed" } : {}}

                        />
                        {errors.Zipcode && (
                          <p style={{ textAlign: "left", color: "red" }}>
                            {" "}
                            {errors.Zipcode}
                          </p>
                        )}
                      </div>
                      <div className="form-entity">
                        <label>State*</label>
                        <input
                          type="text"
                          name="StateId"
                          maxLength={30}
                          value={formData?.StateId}
                          onChange={handleInputChange}
                          disabled={!canEditEntityInfo || !!formData?.StateId}
                          style={!canEditEntityInfo || formData?.StateId ? { cursor: "not-allowed" } : {}}
                        />
                        {errors.StateId && (
                          <p style={{ textAlign: "left", color: "red" }}>
                            {" "}
                            {errors.StateId}
                          </p>
                        )}
                      </div>
                      <div className="form-entity">
                        <label>City*</label>
                        <input
                          type="text"
                          name="CityId"
                          maxLength={30}
                          value={formData?.CityId}
                          onChange={handleInputChange}
                          disabled={!canEditEntityInfo || !!formData?.CityId}
                          style={!canEditEntityInfo || formData?.CityId ? { cursor: "not-allowed" } : {}}

                        />
                        {errors.CityId && (
                          <p style={{ textAlign: "left", color: "red" }}>
                            {" "}
                            {errors.CityId}
                          </p>
                        )}
                      </div>
                      <div className="form-entity"></div>
                      {canEditEntityInfo && (
                        <div className="form-entity">
                          <button
                            type="button"
                            className="save-changes-button"
                            onClick={handleSaveChanges}
                          >
                            Save Changes
                          </button>
                        </div>
                      )}
                    </form>
                  </div>
                )}
                {activeSection === "profile" && (userInfo || empInfo) && (
                  <div className="entity-info-container">
                    <h2 style={{ textAlign: "left" }}>Profile Information</h2>
                    <hr />
                    <form className="entity-form">
                      <div className="form-entity">
                        <label>First Name*</label>
                        <input
                          type="text"
                          name="FirstName"
                          value={profileData?.FirstName}
                          onChange={handleProfileChange}
                        />
                        {errors.FirstName && (
                          <p style={{ textAlign: "left", color: "red" }}>
                            {" "}
                            {errors.FirstName}
                          </p>
                        )}
                      </div>
                      <div className="form-entity">
                        <label>Last Name*</label>
                        <input
                          type="text"
                          name="LastName"
                          value={profileData?.LastName}
                          onChange={handleProfileChange}
                        />
                        {errors.LastName && (
                          <p style={{ textAlign: "left", color: "red" }}>
                            {" "}
                            {errors.LastName}
                          </p>
                        )}
                      </div>
                      <div className="form-entity">
                        <label>Email*</label>
                        <input
                          type="email"
                          name="EmailId"
                          value={profileData?.EmailId}
                          onChange={handleProfileChange}
                        />
                        {errors.EmailId && (
                          <p style={{ textAlign: "left", color: "red" }}>
                            {" "}
                            {errors.EmailId}
                          </p>
                        )}
                      </div>
                      <div className="form-entity">
                        <label>Mobile Number*</label>
                        <PhoneInput
                          international
                          countryCallingCodeEditable={false}
                          name="MobileNumber"
                          maxLength={15}
                          value={profileData?.MobileNumber}
                          id="MobileNumber"
                          placeholder="Enter phone number"
                          defaultCountry='US'
                          countries={['US']}
                          onChange={(value) => handleProfileChange({ target: { name: "MobileNumber", value } })}
                          className="CustomPhoneInput" />
                        {errors.MobileNumber && (
                          <p style={{ textAlign: "left", color: "red" }}>
                            {" "}
                            {errors.MobileNumber}
                          </p>
                        )}
                      </div>
                      <div className="form-entity">
                        <label>Entity Office Number</label>
                        <PhoneInput
                          international
                          countryCallingCodeEditable={false}
                          name="OfficeNumber"
                          maxLength={15}
                          value={profileData?.OfficeNumber}
                          id="OfficeNumber"
                          countries={['US']}
                          placeholder="Enter office number"
                          defaultCountry='US'
                          className="CustomPhoneInput"
                          onChange={(value) => handleProfileChange({ target: { name: "OfficeNumber", value } })}
                        />
                        {errors.OfficeNumber && (
                          <p style={{ textAlign: "left", color: "red" }}>
                            {" "}
                            {errors.OfficeNumber}
                          </p>
                        )}
                      </div>
                      <div className="form-entity"></div>
                      <div className="form-entity">
                        <button
                          type="button"
                          className="save-changes-button"
                          onClick={() => handleSaveChanges("profile")}
                        >
                          Save Changes
                        </button>
                      </div>
                    </form>
                  </div>
                )}
                {activeSection === "password" && (userInfo || empInfo) && (
                  <>
                    <div className="entity-info-container">
                      <h2 className="password-header">Change Password</h2>
                      <hr />
                      <div className="change-password-info">
                        <p className="password-text">
                          To change your password, we use a secure identity provider.
                        </p>
                        <p className="password-text">
                          First, you’ll be asked to verify your email. After verification, you’ll be prompted
                          to set your new password.
                        </p>
                        <p className="password-text bottom-spacing">
                          Click the button below to begin the process.
                        </p>
                        <button
                          className="change-password-button"
                          onClick={() => handleResetPassword()}
                          disabled={isAuthInProgress}
                        >
                          Change Password
                        </button>
                      </div>
                    </div>

                    {showSuccessDialog && (
                      <div className="dialog-overlay">
                        <div className="dialog-box success">
                          <div className="dialog-success-header">
                            <CheckCircleOutlineIcon className="dialog-icon" />
                            <h3 className="dialog-title">Password Updated Successfully</h3>
                          </div>
                          <button
                            className="dialog-ok-button1"
                            onClick={() => setShowSuccessDialog(false)}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    )}
                  </>
                )}
                {activeSection === 'agreementSignature' && userInfo && (
                  <>
                    <div className="entity-info-container">
                      <div className="reit-header">
                        <h2>Registered REITs Document</h2>
                        <a href={pdfUrl} target="_blank" rel="noreferrer">
                          <button>Download</button>
                        </a>
                      </div>
                      <hr />
                      <div className="pdf-height">
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                          <Viewer fileUrl={pdfUrl} plugins={[defaultLayoutPluginInstance]} />
                        </Worker>
                      </div>
                    </div>
                  </>
                )}




                {activeSection === "pricing" && (
                  <>
                    {(userInfo || empInfo) && (
                      <div className="pricing-info-container">
                        <h2>Parking Fees Charged</h2>
                        <h5 style={{ textAlign: 'center' }}>Below are the current fees charged per parking space per hour</h5>
                        <p>Note: Billing is incurred/Invoiced per minute</p>
                        <h6>PARKING CHARGED TO AUTONOMOUS VEHICLE/ROBOTAXI</h6>
                        <ul>
                          <li className="description">
                            $0.50 Price Per Hour 7pm-7am Weekdays (Mon-Thurs)<br></br>
                            Percentage of parking fees you receive: 70%
                          </li>
                          <li className="description">
                            $0.75 Price Per Hour 7am-7pm Weekdays (Mon-Fri) <br></br>
                            Percentage of parking fees you receive: 70%
                            {/* <span className="price">$0.75</span> */}
                          </li>
                          <li className="description">
                            $0.25 Price Per Hour 7pm-7am Weekends (Fri-Mon) <br></br>
                            Percentage of parking fees you receive: 70%
                            {/* <span className="price">$0.25</span> */}
                          </li>
                        </ul>
                      </div>
                    )}
                    {internalEmployeeEmail && <Pricing />}
                  </>
                )}
                {activeSection === "holidays" && internalEmployeeEmail && (
                  <>
                    <Holidays />
                  </>
                )}


              </div>
            </div>
          </>
          {showConfirmation && (
            <div className="confirmation-popup">
              <div className="confirmation-popup-content">
                <p>Are you sure you want to save the changes?</p>
                <button className="Confirm" onClick={confirmSaveChanges}>
                  Confirm
                </button>
                <button className="Cancel" onClick={cancelSaveChanges}>
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div >
      ) : (
        <div>
          {!showdialogue && verificationenabled && (
            <SignUP
              updateProfile={updateProfile}
              personaldata={personalData}
              entityData={formData}
              verificationRequired={verificationRequired}
              stateLogedInUser={stateLogedInUser}
              radiobuttonval={radiobuttonval}
              setRadiobuttonval={setRadiobuttonval}
              oldNumber={oldMobilenum}
              handleBack={handleBack}
              onProfileUpdateComplete={handleProfileUpdateComplete}
            />
          )}
        </div>
      )}
      <BootstrapDialog
        //onClose={handleContinue}
        classes={{ paper: "custom-paper-class" }}
        aria-labelledby="customized-dialog-title"
        dividers
        sx={{
          textAlign: "start",
          overflowY: "auto",
          padding: "5rem 5rem",
          borderRadius: "5px",
        }}
        open={showdialogue}
      >
        <DialogTitle
          dividers
          sx={{
            textAlign: "start",
            color: "rgba(51, 51, 51, 1)",
            fontSize: "24px",
            fontWeight: "700",
          }}
          id="customized-dialog-title"
        >
          Verify that its you..
        </DialogTitle>
        <DialogContent style={{ border: "none" }}>
          <Typography gutterBottom>
            <span>
              Confirm your identity by selecting your current email or phone.
              Will send the One Time Verification Code.
              This ensures your account stays secure.
            </span>
          </Typography>
          <div>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              onClick={(e) => handleradiobutton(e.target.value)}
            >
              <FormControlLabel
                sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                value="phone"
                control={<Radio />}
                label="Phone"
                className="radiolabel"
              />
              <FormControlLabel
                sx={{ "& .MuiSvgIcon-root": { fontSize: 28 } }}
                value="email"
                control={<Radio />}
                label="Email"
                className="radiolabel"
              />
            </RadioGroup>
          </div>
        </DialogContent>
        <DialogActions sx={{ justifyContent: 'center' }}>
          <Button
            className='mb-3'
            autoFocus
            onClick={handleContinue}
            classes={{ root: "Secondary" }}
            sx={{
              width: "150px",
              height: "50px",
              backgroundColor: "#6BCD55",
              color: "#000",
              fontFamily: "Montserrat",
              fontSize: "17px",
              fontStyle: "normal",
              fontWeight: 700,
              "&:hover": { backgroundColor: "#5aa949" },
            }}
          >
            <span>Continue</span>
          </Button>
          <Button
            className="mb-3"
            autoFocus
            classes={{ root: "Secondary" }}
            onClick={handleCancel}
            sx={{
              width: "150px",
              height: "50px",
              backgroundColor: "#6BCD55",
              color: "#000",
              fontFamily: "Montserrat",
              fontSize: "17px",
              fontStyle: "normal",
              fontWeight: 700,
              backgroundColor: "lightgrey",
              "&:hover": { backgroundColor: "#A9A9A9" },
            }}
          >
            <span>Cancel</span>
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </>
  )
}
export default SettingEntityInfo;
